import React from 'react';

import Container from './Container.jsx';
import Utilities from '../utility/Utilities.jsx';

function ContentContainer(props) {
    let className = 'editable';
    if (props.className) {
        className += ` ${props.className}`;
    }
    return (
        <Container
            builder={props.builder}
            className={className}
            config={props.collateralConfig}
            style={props.containerStyle}
            onClick={props.onClick}
            onDragEnter={props.onDragEnter}
            onDragStart={props.onDragStart}>
            <tr style={props.builder && !props.editor ? { pointerEvents: 'none' } : undefined}>
                <td>
                    {props.content}
                </td>
            </tr>
            {
                props.builder &&
                <tr>
                    <td>
                        {
                            (!props.content || props.content.length == 0) &&
                            Utilities.Builder.emptyBlockPlaceholder()
                        }
                        {Utilities.Builder.dragOutline()}
                    </td>
                </tr>
            }
        </Container>
    )
}

export default ContentContainer;